var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"app-main"},[_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1)],1),_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }